import React, { useMemo } from 'react';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import {
  isToday, isYesterday, isThisWeek, isThisMonth,
} from 'date-fns';
import { Typography } from '@mui/material';
import { ContextMenuItemType } from '@marageti/z4-lib';
import TripRequestCard from '../../../components/list-cards/trip-request-cards/all-card';

type DateSeparatedListProps = {
  dateField: string,
  items?: {
    tripRequest: TripRequest,
    contextMenuItems: ContextMenuItemType[] | undefined,
  }[],
};

// Using createdAt for date until the backend provides a field for date of most recent activity
// Search data is fetched in the correct sort order
const DateSeparatedList = ({
  dateField,
  items = undefined,
}: DateSeparatedListProps) => {
  const buckets = useMemo(() => {
    if (!items || items.length === 0) return undefined;
    const b: { [key: string]: {
      tripRequest: TripRequest,
      contextMenuItems: ContextMenuItemType[] | undefined,
    }[] } = {
      today: [],
      yesterday: [],
      thisWeek: [],
      thisMonth: [],
      older: [],
    };
    if (items) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < items.length; i++) {
        const tr = items[i].tripRequest;
        const v = tr[dateField as keyof TripRequest] as string;
        const date = new Date(v);
        if (isToday(date)) b.today.push(items[i]);
        else if (isYesterday(date)) b.yesterday.push(items[i]);
        else if (isThisWeek(date)) b.thisWeek.push(items[i]);
        else if (isThisMonth(date)) b.thisMonth.push(items[i]);
        else {
          b.older = (items.slice(i));
          break;
        }
      }
    }
    return b;
  }, [items, dateField]);

  return buckets ? (
    <>
      {buckets.today.map((item) => (
        <TripRequestCard key={item.tripRequest.id} tripRequest={item.tripRequest} contextMenuOptions={item.contextMenuItems} />
      ))}
      {buckets.yesterday.length > 0 && <Typography variant="captionBold" pt={2}>Yesterday</Typography>}
      {buckets.yesterday.map((item) => (
        <TripRequestCard key={item.tripRequest.id} tripRequest={item.tripRequest} contextMenuOptions={item.contextMenuItems} />
      ))}
      {buckets.thisWeek.length > 0 && <Typography variant="captionBold" pt={2}>This Week</Typography>}
      {buckets.thisWeek.map((item) => (
        <TripRequestCard key={item.tripRequest.id} tripRequest={item.tripRequest} contextMenuOptions={item.contextMenuItems} />
      ))}
      {buckets.thisMonth.length > 0 && <Typography variant="captionBold" pt={2}>This Month</Typography>}
      {buckets.thisMonth.map((item) => (
        <TripRequestCard key={item.tripRequest.id} tripRequest={item.tripRequest} contextMenuOptions={item.contextMenuItems} />
      ))}
      {buckets.older.length > 0 && <Typography variant="captionBold" pt={2}>Older</Typography>}
      {buckets.older.map((item) => (
        <TripRequestCard key={item.tripRequest.id} tripRequest={item.tripRequest} contextMenuOptions={item.contextMenuItems} />
      ))}
    </>
  ) : null;
};

export default DateSeparatedList;
